<template>
  <el-form-item
    :label="form.name"
    :prop="form.model"
    :class="[form.options.required?'label-blue':'']"
    :rules="form.rules"
    :required="form.options.required"
     style="padding-left:10px;line-height:36px;"
  >
    <el-row style="width:226px">
      <el-col v-if="form.pickerOptions.type === 'start'">
        <el-time-select
         style="width:100%"
          v-model="value[form.model]"
          :placeholder="form.options.placeholder"
          :disabled="inputDisable"
          @input="onInput"

          :picker-options="{
            start: form.pickerOptions.start,
            step: form.pickerOptions.step,
            end: form.pickerOptions.end,
            maxTime: form.pickerOptions.maxTime
          }">
        </el-time-select>
      </el-col>
      <el-col v-else-if="form.pickerOptions.type==='end'">
        <el-time-select
         style="width:100%"
          v-model="value[form.model]"
          :placeholder="form.options.placeholder"
          :disabled="inputDisable"
          @input="onInput"

          :picker-options="{
            start: form.pickerOptions.start,
            step: form.pickerOptions.step,
            end: form.pickerOptions.end,
            minTime: form.pickerOptions.minTime,
          }">
        </el-time-select>
      </el-col>
    </el-row>
  </el-form-item>
</template>

<script>
export default {
  name: "DynamicTimePicker",
  data() {
    let _this=this;
    return {
      key: "",
      formData: {},
      mainValue: "",
    };
  },
  props: {
    form: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
          name: "",
          prop: "",
          icon: "",
          className: "",
          options: {
            width: "100%",
            defaultValue: "",
            required: false,
            dataType: "time",
            pattern: "",
            placeholder: "",
            customClass: "",
            disabled: false,
            remoteFunc: () => {},
            changeFunc: () => {}
          },
          key: "",
          model: "value",
          rules: [{}]
        };
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "value"
  },
  watch: {
    value: {
      immediate: true,
      handler: function(val, oldVal) {
        this.mainValue = val;
      }
    }
  },
  methods: {
    onInput() {
      let that = this;
      that.$emit("input", that.value, that.form.model);
      if (typeof that.form.options.changeFunc === "function") {
        // 判断是否存在数据改变事件
        that.form.options.changeFunc(
          that.value[that.form.model],
          that,
          that.forms
        );
      }
    },
    setValue(val) {
      this.mainValue = val;
    },
  },
  created() {
    let that = this;
    that.key = that.form.key;
    if (that.form.hasOwnProperty("options")) {
      that.value[that.form.model] =
        that.value[that.form.model] ||
        this.form["options"]["defaultValue"] ||
        "";
    }
  },
  mounted() {
    let that = this;
    that.$emit("init", that.key, that);
  },
  computed: {
    inputDisable() {
      return this.disabled || this.form.options.disabled;
    },
  }
};
</script>

<style scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Form/DynamicTimePicker.vue"
}
</vue-filename-injector>
